import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig";
let moduleConfig = {};
moduleConfig = {
  ...moduleDefaultConfig,
};

moduleConfig.title = "Special Meal Discounts";
moduleConfig.singleItemTitle = "Special Meal Discounts";
moduleConfig.url = "special-meal-discounts";
moduleConfig.moduleType = {
  listing: "block",
  view: "block",
};

moduleConfig.imageRequirement = null;
moduleConfig.breadcrumbs = {
  listing: {
    label: moduleConfig.title,
    url: `/${moduleConfig.url}`,
  },
  // details: {
  //   label: "Details",
  //   url: `/${moduleConfig.url}/${id}`,
  // },
  update: {
    label: "Update",
  },
  create: {
    label: "Create",
  },
}


export default moduleConfig;
